import type { PluginConfigComponentProps } from '../types';

export type PortalClienteConfig = Record<string, never>;

export const PortalClienteConfigComponent = (
  _props: PluginConfigComponentProps<PortalClienteConfig>,
) => {
  return (
    <div className="text-sm text-muted-foreground">
      Esse plugin não tem configurações. Ative ou desative pelo card.
    </div>
  );
};
